import hrIcon from '~/assets/icons/logistics/hr.svg'
import hubsIcon from '~/assets/icons/logistics/hubs.svg'
import operationsIcon from '~/assets/icons/logistics/operations.svg'
import simulatorIcon from '~/assets/icons/logistics/simulator.svg'
import vehiclesIcon from '~/assets/icons/logistics/vehicles.svg'
import type { AppTab } from '~/components/new/app-ui/app-tabs'
import type { LogisticsTabValue } from '~/routes/_authenticated/logistics/-search-schema'
import type { GuardedTab } from '~/utils/rbacTabs'
import { LOGISTICS_TAB_PERMISSIONS } from './logistics-rights'
import { maskIconOf } from './mask-icon'

/** Onglets de la page Logistique ; les exigences de droits vivent dans `logistics-rights.ts`. */
export * from './logistics-rights'

type LogisticsTabDefinition = GuardedTab<LogisticsTabValue> &
  Pick<AppTab<LogisticsTabValue>, 'icon' | 'separatorBefore'> & {
    /** Onglet annoncé mais pas encore livré : toujours désactivé, jamais sélectionné. */
    comingSoon?: boolean
  }

/** Ordre de déclaration = ordre d'affichage, et ordre de repli quand l'onglet actif est interdit. */
export const LOGISTICS_TABS: LogisticsTabDefinition[] = [
  {
    value: 'simulator',
    label: 'Simulateur',
    icon: maskIconOf(simulatorIcon),
    permission: LOGISTICS_TAB_PERMISSIONS.simulator,
  },
  {
    value: 'operations',
    label: 'Gestion opérationnelle',
    icon: maskIconOf(operationsIcon),
    comingSoon: true,
  },
  {
    value: 'hubs',
    label: 'Hubs',
    icon: maskIconOf(hubsIcon),
    separatorBefore: true,
    permission: LOGISTICS_TAB_PERMISSIONS.hubs,
  },
  {
    value: 'vehicles',
    label: 'Camions',
    icon: maskIconOf(vehiclesIcon),
    permission: LOGISTICS_TAB_PERMISSIONS.vehicles,
  },
  {
    value: 'hr',
    label: 'RH',
    icon: maskIconOf(hrIcon),
    permission: LOGISTICS_TAB_PERMISSIONS.hr,
  },
]
